// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"71d9f5e6","856":"4cc9d310"}[chunkId] + ".chunk.js";
};